import { Controller } from '@hotwired/stimulus'

export class AntTableBulkActionsController extends Controller {
  static targets = ['selectedIds']

  declare selectedIdsTarget: HTMLInputElement

  connect() {
    document.addEventListener(
      'selectionChanged',
      this.updateSelectedIds.bind(this),
    )
    this.updateSelectedIdsFromBody()
  }

  disconnect() {
    document.removeEventListener(
      'selectionChanged',
      this.updateSelectedIds.bind(this),
    )
  }

  updateSelectedIds(event: CustomEvent) {
    this.setSelectedIds(event.detail.selectedIds)
  }

  declare readonly hasSelectedIdsTarget: boolean
  updateSelectedIdsFromBody() {
    const selectedIds = JSON.parse(
      document.body.getAttribute('data-selected-table-ids') || '[]',
    )
    this.setSelectedIds(selectedIds)
  }

  private setSelectedIds(ids: any[]) {
    if (this.hasSelectedIdsTarget) {
      this.selectedIdsTarget.value = JSON.stringify(ids)
    }
  }
}
